export const toolbarComponentOverrides = {
    MuiToolbar: {
        variants: [
            {
                props: {
                    variant: 'stepper'
                },
                style: ({ theme }) => ({
                    background: theme.tokens.FuelColorWhite,
                    display: 'grid',
                    paddingInline: theme.tokens.FuelSpacing4,
                    paddingBlock: theme.tokens.FuelSpacing2,
                    gridTemplateColumns: 'auto 1fr auto',
                    gap: theme.tokens.FuelSpacing4
                })
            }, {
                props: {
                    variant: 'stepper-drawer'
                },
                style: ({ theme }) => ({
                    background: theme.tokens.FuelColorWhite,
                    marginBottom: theme.tokens.FuelSpacing4,
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: theme.tokens.FuelSpacing2
                })
            }
        ]
    }
};
